export enum WorkflowPhase {
  PreApproval = 'PreApproval',
  InProgress = 'InProgress',
}
